<template>
	<label :for="idCode" :class="[style.inputLabel, theme == 'black' ? style.inputLabelBlack : style.inputLabelWhite]">
		<slot></slot>
		<text-input 
				:id="id"
				:size="size" 
				:value="value" 
				:name="name" 
				:error="error" 
				:customInputStyles="customInputStyles"
				:isPassword="isPassword"  
				:placeholder="placeholder" 
				:disabled="disabled"
				:mask="mask"
				:style="'max-width:' + maxWidth " 
				:autocomplete="autocomplete"
				@input="$emit('input', $event)" 			
                @blur="$emit('blur', $event)"
				@keyup="$emit('keyup', $event)"
                @keyup-up="$emit('keyup-up', $event)"
				@keyup-down="$emit('keyup-down', $event)"
				@keyup-enter="$emit('keyup-enter', $event)"
				@focus="$emit('focus', $event)"
				@click="$emit('click', $event)"
                />
        <span :class="[style.inputLabelDesc]">
			<slot name="desc"></slot>
		</span>
	</label>
</template>

<script>
	import style from './style.module.scss'
	import textInput from './text-input'

	import { textInputProps } from './text-input-mixin'

	export default {
		name: 'input-label',
		components: {
			textInput
		},
		props: {
			maxWidth: {
				type: String,
				default: '',
				required: false
			},
			mask: {
				type: String,
				default: 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
				required: false
			},
			customInputStyles: {
				type: Array,
				default() {
					return [];
				}
			},
			disabled: {
				type: String,
				default: ''
			}
		},
		mixins: [textInputProps],
		methods: {
			test() {
				console.log('teeeest')
			}
		},
		data() {
			return {
				style: style,
				idCode: `f${(~~(Math.random()*1e8)).toString(16)}`
			}
		},
	}
</script>